import { observer } from "mobx-react-lite";

import { useStores } from "stores";
import { getTotalDocumentsCount } from "utils";
import { ContractFilesBlock } from "../ContractFilesBlock";
import { ContractBidsList } from "../ContractBidsList";
import { CustomTabs } from "ui/CustomTabs";

interface ContractTabsProps {
  contractId: string;
  showBidsList: boolean;
}

export const ContractTabs = observer(({ contractId, showBidsList }: ContractTabsProps) => {
  const { contractCard, contractBids } = useStores();

  const documentsCount = getTotalDocumentsCount(contractCard.card.documents);
  const bidsCount = contractBids.paginationData.totalElements;

  return (
    <CustomTabs
      items={[
        ...(showBidsList
          ? [
              {
                key: "bids",
                title: "Заявки на оплату",
                count: bidsCount,
                children: <ContractBidsList id={contractId} />,
              },
            ]
          : []),
        {
          key: "documents",
          title: "Документы",
          count: documentsCount,
          children: <ContractFilesBlock />,
        },
      ]}
    />
  );
});
